import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

/*----------------------------------------
  FAQ
------------------------------------------*/
let accordionDetails = '.qa-item';
let accordionSummary = '.q_item';
let accordionContent = '.a_item';
let speed = 300;

$(accordionSummary + ',' + accordionContent).each(function () {
  $(this).on("click", function (event) {
    event.preventDefault();

    let $qaItem = $(this).closest(accordionDetails);
    let $summary = $qaItem.find(accordionSummary);
    let $content = $qaItem.find(accordionContent);
    let $icon = $qaItem.find(".q_icon");

    // クラス切り替え
    $summary.toggleClass("is-active");
    $icon.toggleClass("is-active");

    if ($qaItem.attr("open")) {
      // アコーディオンを閉じるとき
      $content.slideUp(speed, function () {
        $qaItem.removeAttr("open");
      });
    } else {
      // アコーディオンを開くとき
      $qaItem.attr("open", "true");
      $content.hide().slideDown(speed);
    }
  });
});

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
let button = document.querySelector('.hd_menu_btn');
let nav_box = document.querySelector('.hd_nav_box');

if (button && nav_box) {
  button.addEventListener('click', function() {

    if (nav_box.classList.contains('is_open')) {
      nav_box.classList.remove("is_open");
      button.classList.remove("is_close");
    } else {
      nav_box.classList.add("is_open");
      button.classList.add("is_close");
    }

  });
}

/*------------------------------------------------
ハンバーガーメニュー　リンク押したらメニュー閉じる
--------------------------------------------------*/
  let links = document.querySelectorAll('.hd_nav_link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });

/*----------------------------------------
お問い合わせ アニメーション
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
function getHeaderHeight() {
  const header = document.querySelector('.header');
  return header ? header.offsetHeight : 0;
}

document.addEventListener('tccf7:scrollTo', e => {
  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: getHeaderHeight()
    },
    ease: "power2.inOut"
  });
});

// /*----------------------------------------
// お問い合わせバリデーション
// ------------------------------------------*/
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}

/*----------------------------------------
  ヘッダー動き
------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const mainSection = document.querySelector('.main');

  if (!header || !mainSection) return;

  let scrollHandler = null;

  const handleScroll = () => {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const viewportHeight = window.innerHeight;
    const threshold = viewportHeight - 250;

    if (scroll > threshold) {
      header.classList.add('is_fixed');
    } else {
      header.classList.remove('is_fixed');
    }
  };

  const updateScrollEvent = () => {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const mainTop = mainSection.offsetTop;

    // 画面幅が1024以上かつ main の上端が画面の一番上に来たらスクロールイベントを有効化
    if (window.innerWidth >= 1024 && scroll >= mainTop) {
      if (!scrollHandler) {
        scrollHandler = handleScroll;
        window.addEventListener('scroll', scrollHandler);
        handleScroll(); // 初回判定
      }
    } else {
      // 画面幅が1024未満、または main の上端前 → イベント削除
      if (scrollHandler) {
        window.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
        header.classList.remove('is_fixed');
      }
    }
  };

  // 初回実行
  updateScrollEvent();

  // スクロール時に main 上端判定
  window.addEventListener('scroll', updateScrollEvent);

  // リサイズ時にも判定
  window.addEventListener('resize', updateScrollEvent);
});

/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
gsap.registerPlugin(ScrollToPlugin);
window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('.header');


  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      e.preventDefault();
      const id = navLink.getAttribute("href");
      const headerHeight = header ? header.offsetHeight : 0;


      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: id,
          offsetY: headerHeight  // ← headerの高さを使う
        }
      });
    });
  });
});

/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;


    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 80);
  }
});

/*----------------------------------------
要素アニメーション
------------------------------------------*/
const item = document.querySelectorAll('.scrollAnim');
item.forEach((target) => {
  ScrollTrigger.create({
    trigger: target,
    start: "top 90%",
    onEnter: () => target.classList.add('active'), // その要素自身にクラスを付ける
  });
});

/*----------------------------------------
雲のアニメーション
------------------------------------------*/
// 1. 監視したいクラスをまとめて取得（カンマ区切りで追加可能）
const targets = document.querySelectorAll('.item_left, .item_right');

// 2. オプション設定
const options = {
  root: null,
  rootMargin: '0px 0px -40% 0px',
  threshold: 0
};

// 3. 実行する関数
const callback = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-show');
      observer.unobserve(entry.target);
    }
  });
};

const observer = new IntersectionObserver(callback, options);

targets.forEach(target => {
  observer.observe(target);
});

/*------------------------------------------------
初回のみOPアニメーション表示
--------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const loading = document.getElementById('svgLoading');
  const firstVisit = sessionStorage.getItem('firstVisit') !== 'done';

  if (firstVisit) {
    loading.classList.add('show'); //クラス追加

    setTimeout(() => {
      loading.style.opacity = '0';
      loading.style.transition = 'opacity 1s ease';

      setTimeout(() => {
        loading.remove();
      }, 1200);

    },1600);

    sessionStorage.setItem('firstVisit', 'done');
  } else {
    loading.remove();
  }
});